import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import fun from '@/units/apiAction'
Vue.prototype.getToken = fun
Vue.config.productionTip = false
import { Menu,Breadcrumb } from 'ant-design-vue';
Vue.use(Menu)
Vue.use(Breadcrumb)
new Vue({
  router,
  render: h => h(App),
  fun
}).$mount('#app')
